module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-clearfix line"
  }, [_c('div', {
    staticClass: "fetch",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('div', {
    staticClass: "line-chart"
  }, [_c('canvas', {
    attrs: {
      "id": _vm.chartid
    }
  })]), _vm._v(" "), (_vm.hasResults) ? _c('div', {
    staticClass: "line-legend"
  }, [_c('ul', _vm._l((_vm.legend), function(series) {
    return _c('li', [_c('span', {
      staticClass: "line-legend-series-label"
    }, [_vm._v(_vm._s(series.label))])])
  }))]) : _c('div', {
    staticClass: "line-message",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('p', [_vm._v("No results that match those filters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots line-loader",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e3827d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LineChart.vue
// module id = 472
// module chunks = 1